import React from 'react';
import { Row, Col, FormControl, InputGroup, Button } from 'react-bootstrap';

const Login = (props) => {
	let token = null;

	const setToken = (event) => {
		token = event.target.value;
	}

	const pressEnter = (target) => {
		if(target.charCode === 13 && token != null) {
			updateLocalToken();
		}
	}

	const updateLocalToken = () => {
		// save token
		localStorage.setItem('token', token);

		// set back to orignal path
		const path = localStorage.getItem('original_path') || '/';

		props.history.push(`${path}`);
	}

	return (
		<Row className="enpoint-form">
			<Col sm={12}>
				<InputGroup className="mb-3">
					<InputGroup.Prepend>
						<InputGroup.Text id="basic-addon3">Access Token</InputGroup.Text>
					</InputGroup.Prepend>
					<FormControl 
						id="token" 
						aria-describedby="basic-addon3" 
						placeholder="Enter personal token"
						autoComplete="off"
						onChange={setToken}
						onKeyPress={pressEnter} />
					<InputGroup.Append>
						<Button 
							variant="info" 
							size="sm"
							onClick={updateLocalToken}>
								<i className="fas fa-save"></i> Save
						</Button>
					</InputGroup.Append>
				</InputGroup>
			</Col>
		</Row>
	);
}

export default Login;